<footer>
    <div>
        © Copyright {{ currentYear }} BMW Group | BMW International Feedback
        Management Tool | Version {{ version }}
    </div>
</footer>
